import ReactEChartsCore from 'echarts-for-react/lib/core';
import { echarts, COLOR_PALETTE } from '../../shared/echarts-config';
import { ChartContainer } from '../../shared/ChartContainer';
import { EmptyState } from '../../shared/EmptyState';
import type { FpServiceSlice } from '../../../../types/analytics.types';

type TopClientActionsDonutProps = {
  actions: FpServiceSlice[];
};

const TITLE = 'Top Client Actions';
const SUBTITLE = 'How clients engage: searches, messages, consultations';

const buildOptions = (actions: FpServiceSlice[]) => ({
  tooltip: {
    trigger: 'item' as const,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderColor: '#e5e7eb',
    borderWidth: 1,
    textStyle: { color: '#374151', fontSize: 13 },
    formatter: '{b}: {c} ({d}%)',
  },
  legend: {
    orient: 'vertical' as const,
    right: '2%',
    top: 'middle',
    icon: 'circle',
    textStyle: { color: '#374151', fontSize: 13 },
    formatter: (name: string) => {
      const slice = actions.find((a) => a.categoryName === name);
      return slice ? `${name}  ${slice.count}  ${slice.percentage}%` : name;
    },
  },
  series: [
    {
      name: TITLE,
      type: 'pie' as const,
      radius: ['45%', '70%'],
      center: ['32%', '50%'],
      avoidLabelOverlap: true,
      label: { show: false },
      labelLine: { show: false },
      data: actions.map((a, i) => ({
        name: a.categoryName,
        value: a.count,
        itemStyle: { color: COLOR_PALETTE[i % COLOR_PALETTE.length] },
      })),
    },
  ],
});

export const TopClientActionsDonut = ({ actions }: TopClientActionsDonutProps) => {
  if (actions.length === 0 || actions.every((a) => a.count === 0)) {
    return (
      <ChartContainer title={TITLE} subtitle={SUBTITLE}>
        <EmptyState message="No client actions for the selected filters." />
      </ChartContainer>
    );
  }

  return (
    <ChartContainer title={TITLE} subtitle={SUBTITLE}>
      <ReactEChartsCore
        echarts={echarts}
        option={buildOptions(actions)}
        style={{ height: 300 }}
        notMerge
        lazyUpdate
      />
    </ChartContainer>
  );
};
